var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"pages"},[_c('router-link',{attrs:{"to":"/"}},[_c('h3',[_vm._v("Login")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }